import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { EeaArticleService } from 'src/api/v2';
import { EEA_ARTICLES_KEY } from 'src/constants/hook-keys';

const useEeaArticles = () => {
  const [eeaArticleService] = useState(() => new EeaArticleService());

  const { data, ...rest } = useQuery({
    queryFn: () => eeaArticleService.getEeaArticles(),
    queryKey: [EEA_ARTICLES_KEY],
    retry: false,
  });

  const filteredEeaArticles = data?.filter((article) => article.name !== 'Ikke relevant');

  return {
    eeaArticles: filteredEeaArticles,
    ...rest,
  };
};

export default useEeaArticles;
